import type { SettingsSectionKey } from '../components/SettingsOverlay';

export const OPEN_SETTINGS_OVERLAY_EVENT = 'wapharma-open-settings-overlay';

export type OpenSettingsOverlayRequest = {
  section?: SettingsSectionKey;
  /** Deep-link into Références catalog row (SOP-*). */
  sopId?: string;
};

export function openSettingsOverlay(
  section?: SettingsSectionKey,
  opts?: { sopId?: string },
) {
  window.dispatchEvent(
    new CustomEvent<OpenSettingsOverlayRequest>(OPEN_SETTINGS_OVERLAY_EVENT, {
      detail: { section, sopId: opts?.sopId },
    }),
  );
}

export function subscribeOpenSettingsOverlay(
  listener: (request: OpenSettingsOverlayRequest) => void,
): () => void {
  const handler = (event: Event) => {
    listener((event as CustomEvent<OpenSettingsOverlayRequest>).detail ?? {});
  };
  window.addEventListener(OPEN_SETTINGS_OVERLAY_EVENT, handler);
  return () => window.removeEventListener(OPEN_SETTINGS_OVERLAY_EVENT, handler);
}
